export const getItemCount = ({ search: { itemCount } }) => itemCount;
